/** * Component ResumeCard * * Display an image to right and to left display a
smart list. Include a link for have more informations. * * Props : * - alt
(String) : display text if the image isn't visible * - src (String) : url on the
image to display * - item1, item2, item3 (String) : text fort each item in the
list * - url (String) : url on the 'PageLink' component * - moreInformations
(String) : text on the link on the 'PageLink' component * - details (Boolean),
exterior (Boolean) : decide if an element display or not * * Intern component :
* - PageLink : component to manage the link to another page */

<template>
  <img
    data-aos="fade"
    data-aos-duration="1000"
    data-aos-easing="ease-in-out"
    data-aos-once="true"
    class="img_container"
    :alt="alt"
    :src="src"
  />
  <div
    class="resume_container"
    data-aos="fade"
    data-aos-duration="1000"
    data-aos-easing="ease-in-out"
    data-aos-once="true"
  >
    <!-- add a item table -->
    <ul class="resume_list">
      <li v-for="(listItem, index) in displayedItems" :key="index" v-html="listItem">
      </li>
    </ul>

    <!-- Affiche le bouton uniquement sur mobile s'il y a plus de 2 items -->
    <button
      v-if="isMobile && items.length > 2"
      @click="showMore = !showMore"
      class="toggle-btn"
    >
      {{ showMore ? $t("home.buttonMore") : $t("home.buttonLess") }}
    </button>

  
  </div>
</template>

<script>
export default {
  name: "ResumeCard",


  data() {
    return {
      showMore: false,
      isMobile: false,
    };
  },
  computed: {
    displayedItems() {
      if (this.isMobile && !this.showMore) {
        return this.items.slice(0, 2);
      }
      return this.items;
    },
  },
  mounted() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },
  },
  props: {
    alt: String,
    src: String,
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import "../assets/styles/_variables.scss";

.resume_container {
  text-align: justify;
}

.img_container {
  width: 100%;
  max-width: 250px;
}

.btn_li_container {
  padding-left: $spacing-large;
}
.resume_li{
  padding-top: 1em;
}
.toggle-btn {
  background: transparent;
  border: none;
  color: $third-color;
  cursor: pointer;
  font-weight: bold;
}

@media (max-width: 768px) {
 .img_container {
  max-width: 21rem;
}
.resume_list{
  list-style-type: none;
  padding-left: 0;
}
.point_container{
  padding-top: 1em;
}
}
</style>
